export const appetizers = [
  {
    id: 'app-1',
    title: 'Bruschetta',
    description: 'Toasted bread with tomato, basil, and fresh mozzarella.',
    price: '$5.99',
    imgSrc: '/assets/bruschetta.jpg',
  },
  {
    id: 'app-2',
    title: 'Stuffed Mushrooms',
    description: 'Mushrooms filled with herbed cream cheese, topped with Parmesan.',
    price: '$7.99',
    imgSrc: '/assets/stuffed-mushrooms.jpg',
  },
  {
    id: 'app-3',
    title: 'Garlic Knots',
    description: 'Knots of pizza dough baked to perfection, served with garlic and marinara sauce.',
    price: '$4.99',
    imgSrc: '/assets/garlic-knots.jpg',
  },
  {
    id: 'app-4',
    title: 'Caprese Salad',
    description: 'Sliced fresh mozzarella, tomatoes, and basil, seasoned with salt and olive oil.',
    price: '$6.99',
    imgSrc: '/assets/caprese-salad.jpg',
  }
];

export const soups = [
  {
    id: 'soup-1',
    title: 'Tomato Basil Soup',
    description: 'A creamy blend of tomatoes and fresh basil topped with croutons.',
    price: '$5.99',
    imgSrc: '/assets/tomato-basil-soup.jpg',
  },
  {
    id: 'soup-2',
    title: 'Chicken Noodle Soup',
    description: 'Classic chicken noodle soup with carrots, celery, and egg noodles.',
    price: '$6.99',
    imgSrc: '/assets/chicken-noodle-soup.jpg',
  },
  {
    id: 'soup-3',
    title: 'Minestrone',
    description: 'Italian vegetable soup made with tomato broth and pasta.',
    price: '$6.49',
    imgSrc: '/assets/minestrone-soup.jpg',
  },
  {
    id: 'soup-4',
    title: 'French Onion Soup',
    description: 'Rich beef broth with caramelized onions, topped with a cheese crouton.',
    price: '$7.99',
    imgSrc: '/assets/french-onion-soup.jpg',
  }
];

export const salads = [
  {
    id: 'salad-1',
    title: 'Caesar Salad',
    description: 'Crisp romaine lettuce, parmesan cheese, croutons, and a creamy Caesar dressing.',
    price: '$9.99',
    imgSrc: '/assets/caesar-salad.jpg',
  },
  {
    id: 'salad-2',
    title: 'Greek Salad',
    description: 'Tomatoes, cucumbers, red onions, olives, feta cheese, and a light olive oil dressing.',
    price: '$10.99',
    imgSrc: '/assets/greek-salad.jpg',
  },
  {
    id: 'salad-3',
    title: 'Cobb Salad',
    description: 'Mixed greens, chicken breast, bacon, avocado, blue cheese, eggs, and a choice of dressing.',
    price: '$12.99',
    imgSrc: '/assets/cobb-salad.jpg',
  },
  {
    id: 'salad-4',
    title: 'Quinoa Salad',
    description: 'Quinoa, cherry tomatoes, cucumbers, parsley, and a lemony olive oil dressing.',
    price: '$8.99',
    imgSrc: '/assets/quinoa-salad.jpg',
  }
];

export const entrees = [
  {
    id: 'entree-1',
    title: 'Steak',
    description: '12 oz. ribeye steak grilled to perfection, served with mashed potatoes and seasonal vegetables.',
    price: '$22.99',
    imgSrc: '/assets/steak.jpg',
  },
  {
    id: 'entree-2',
    title: 'Grilled Salmon',
    description: 'Grilled salmon fillet with a dill butter sauce, served with rice pilaf and asparagus.',
    price: '$19.99',
    imgSrc: '/assets/grilled-salmon.jpg',
  },
  {
    id: 'entree-3',
    title: 'Chicken Alfredo Pasta',
    description: 'Fettuccine pasta tossed in a creamy Alfredo sauce with grilled chicken, garnished with parsley.',
    price: '$15.99',
    imgSrc: '/assets/pasta_alfredo.jpg',
  },
  {
    id: 'entree-4',
    title: 'Vegetarian Lasagna',
    description: 'Layers of pasta, ricotta, mozzarella, and parmesan cheese, and a hearty vegetable tomato sauce.',
    price: '$13.99',
    imgSrc: '/assets/vegetarian-lasagna.jpg',
  },
  {
    id: 'entree-5',
    title: 'Beef Bourguignon',
    description: 'Slow-cooked beef in a rich red wine sauce with mushrooms, carrots, and onions, served over mashed potatoes.',
    price: '$18.99',
    imgSrc: '/assets/beef-bourguignon.jpg',
  }
];

export const desserts = [
  {
    id: 'dessert-1',
    title: 'Tiramisu',
    description: 'Classic Italian dessert made with espresso-soaked ladyfingers, mascarpone cheese, and dusted with cocoa powder.',
    price: '$7.99',
    imgSrc: '/assets/tiramisu.jpg',
  },
  {
    id: 'dessert-2',
    title: 'Cheesecake',
    description: 'Creamy cheesecake on a graham cracker crust, served with your choice of strawberry, blueberry, or raspberry topping.',
    price: '$6.99',
    imgSrc: '/assets/cheesecake.jpg',
  },
  {
    id: 'dessert-3',
    title: 'Chocolate Lava Cake',
    description: 'Moist chocolate cake with a heart of gooey chocolate lava, served with vanilla ice cream.',
    price: '$8.99',
    imgSrc: '/assets/chocolate-lava-cake.jpg',
  },
  {
    id: 'dessert-4',
    title: 'Apple Pie a la Mode',
    description: 'Warm apple pie made with a flaky crust and spiced apple filling, served with vanilla ice cream.',
    price: '$5.99',
    imgSrc: '/assets/apple-pie.jpg',
  },
  {
    id: 'dessert-5',
    title: 'Lemon Sorbet',
    description: 'Refreshing lemon sorbet, served in a natural lemon shell.',
    price: '$4.99',
    imgSrc: '/assets/lemon-sorbet.jpg',
  }
];

export const beverages = [
  {
    id: 'beverage-1',
    title: 'Fresh Lemonade',
    description: 'Homemade lemonade made from freshly squeezed lemons and a touch of sweetness.',
    price: '$3.50',
    imgSrc: '/assets/fresh-lemonade.jpg',
  },
  {
    id: 'beverage-2',
    title: 'Iced Tea',
    description: 'Refreshing iced tea brewed with a hint of peach or raspberry flavor.Enjoy!',
    price: '$2.99',
    imgSrc: '/assets/iced-tea.jpg',
  },
  {
    id: 'beverage-3',
    title: 'Cappuccino',
    description: 'Rich espresso topped with frothy milk and a sprinkle of cinnamon. Served hot or iced.',
    price: '$4.50',
    imgSrc: '/assets/cappuccino.jpg',
  },
  {
    id: 'beverage-4',
    title: 'Craft Beer',
    description: 'Selection of local and imported craft beers. Ask your server for available options.',
    price: '$5.99',
    imgSrc: '/assets/craft-beer.jpg',
  },
  {
    id: 'beverage-5',
    title: 'Wine by the Glass',
    description: 'Choose from our selection of red, white, and rosé wines, curated to complement our menu.',
    price: '$7.99',
    imgSrc: '/assets/wine-glass.jpg',
  }
];
